import { ApiTickets } from 'common/api';
import { Button, Flex, Input, Loader, Message, Modal } from 'components';
import { useState } from 'react';
import * as bi from 'react-bootstrap-icons';

type Stage = 'default' | 'loading' | 'error' | 'success';

interface IProps {
  ticketId: string;
  onClose: (changed: boolean) => void;
}

function CreateRefundModal(props: IProps) {
  const [reason, setReason] = useState<string>('');
  const [stage, setStage] = useState<Stage>('default');
  const [changed, setChanged] = useState<boolean>(false);

  const handleClose = stage !== 'loading' ? () => props.onClose(changed) : undefined;

  const handleSendClick = async () => {
    try {
      setStage('loading');

      const api = ApiTickets.getInstance();
      await api.createRefund(props.ticketId, reason);

      setChanged(true);
      setStage('success');
    } catch {
      setStage('error');
    }
  };

  return (
    <Modal
      header='Возврат билета'
      onClose={handleClose}
      size={400}
    >
      {stage === 'error' && (
        <Flex
          direction='column'
          gap={10}
        >
          <Message type='error'>Произошла ошибка при отправке заявки, попробуйте ещё раз позже!</Message>
          <Button onClick={handleClose}>Закрыть</Button>
        </Flex>
      )}
      {stage === 'success' && (
        <Flex
          direction='column'
          gap={10}
        >
          <Message type='success'>Заявка успешно отправлена перевозчику, ожидайте ответа...</Message>
          <Button onClick={handleClose}>Закрыть</Button>
        </Flex>
      )}
      {stage === 'loading' && (
        <Flex
          justifyContent='center'
          direction='column'
          gap={20}
        >
          <Flex justifyContent='center'>
            <Loader
              size='default'
              variant='line'
              color='blue'
            />
          </Flex>

          <Message type='info'>Дождитесь завершения операции</Message>
        </Flex>
      )}
      {stage === 'default' && (
        <Flex
          direction='column'
          gap={10}
        >
          <Message
            type='info'
            title='Подсказка'
          >
            Рекомендуем вам описать причину, по которой вы хотите запросить возврат средств за билет, это повышает шанс
            одобрения заявки перевозчиком
          </Message>
          <Input
            type='text'
            label='Причина возврата средств'
            placeholder='Я хочу вернуть деньги за билет, потому что...'
            value={reason}
            onChange={setReason}
          />
          <Button
            color='red'
            size='small'
            onClick={handleSendClick}
          >
            <Flex
              alignItems='center'
              justifyContent='center'
              gap={5}
            >
              <bi.Envelope />
              Отправить заявку
            </Flex>
          </Button>
        </Flex>
      )}
    </Modal>
  );
}

export default CreateRefundModal;
